import { render, staticRenderFns } from "./configInputToUser.vue?vue&type=template&id=bb318754&scoped=true&"
import script from "./configInputToUser.vue?vue&type=script&lang=js&"
export * from "./configInputToUser.vue?vue&type=script&lang=js&"
import style0 from "./configInputToUser.vue?vue&type=style&index=0&id=bb318754&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb318754",
  null
  
)

export default component.exports